<template>
  <b-modal
    id="orders-dine-in-order-details-modal"
    size="xl"
    centered
    title="Dine-in Details"
    hide-footer
    @hidden="handleCloseDineInOrderDetails"
  >
    <b-container fluid>
      <b-row
      id="order-details-container"
      class="rounded overflow-hidden"
      v-if="details"
    >
      <b-col
        md="5"
        id="orders-dine-in-transaction-details"
        class="bg-white"
      >
        <div class="transaction-details">
          <div>
            <template v-for="(column, columnIndex) of columnedData">
              <template v-if="getDetails(column.key)">
                <div
                  md="6"
                  :class="['details-label', { 'mt-4': columnIndex > 0 }]"
                  :key="`column-data-${column}-${columnIndex}-label`"
                >
                  {{ column.label }}
                </div>
                <div
                  md="6"
                  :key="`column-data-${column}-${columnIndex}-data`"
                >
                  {{ getDetails(column.key) }}
                </div>
              </template>
            </template>
          </div>
        </div>
        <div class="payment-details border-top">
          <div class="text-primary font-weight-bold h5 mb-4">Payment Details</div>
          <div v-if="details.payment_method">
            <div class="payment-breakdown-label">Mode of Payment</div>
            <div>
              {{  details.payment_method.split("_")[0] }}
            </div>
          </div>
          <div class="mt-3">
            <div class="payment-breakdown-label">Payment Breakdown</div>
            <div>
              {{  getDetails('brand_branch') }}
            </div>
          </div>
          <b-row v-for="(paymentBreakdown, paymentBreakdownIndex) of columnedPaymentBreakdown" :key="paymentBreakdownIndex" class="mt-1">
              <template v-if="paymentBreakdown.key === 'subtotal_amount'">
                <b-col
                  md="6"
                  class="text-capitalize payment-breakdown-label"
                  :key="`column-data-${paymentBreakdown}-${paymentBreakdownIndex}-label`"
                >
                  {{ paymentBreakdown.label }}
                </b-col>
                <b-col
                  md="6"
                  :key="`column-data-${paymentBreakdown}-${paymentBreakdownIndex}-data`"
                  class="text-right payment-breakdown-value"
                >
                  Php
                  {{ transformCurrencyValue(details[paymentBreakdown.key]) }}
                </b-col>
              </template>
              <template
                v-if="
                  paymentBreakdown.key === 'fees' &&
                  details[paymentBreakdown.key]
                "
              >
                <template
                  v-for="(fee, feeIndex) of details[paymentBreakdown.key]"
                >
                  <b-col
                    md="6"
                    class="text-capitalize payment-breakdown-label"
                    :key="`fee-data-${paymentBreakdownIndex}-fee-${feeIndex}-label`"
                  >
                    {{ fee.name }}
                  </b-col>
                  <b-col
                    md="6"
                    :key="`fee-data-${paymentBreakdownIndex}-fee-${feeIndex}-data`"
                    class="text-right payment-breakdown-value"
                  >
                    Php
                    {{ transformCurrencyValue(fee.calculated_amount) }}
                  </b-col>
                </template>
              </template>
              <template
                v-if="
                  paymentBreakdown.key === 'voucher_list' &&
                  details[paymentBreakdown.key]
                "
              >
                <template
                  v-for="(voucher, voucherIndex) of details[paymentBreakdown.key]"
                >
                  <b-col
                    md="6"
                    class="text-capitalize text-truncate payment-breakdown-label font-weight-bold text-success"
                    :key="`voucher-data-${paymentBreakdownIndex}-voucher-${voucherIndex}-label`"
                  >
                    Promo: {{ voucher.name }}
                  </b-col>
                  <b-col
                    md="6"
                    :key="`voucher-data-${paymentBreakdownIndex}-voucher-${voucherIndex}-data`"
                    class="text-right payment-breakdown-value font-weight-bold text-success"
                  >
                    - Php
                    {{ transformCurrencyValue(voucher.discount_amount) }}
                  </b-col>
                </template>
              </template>
              <template v-if="paymentBreakdown.key === 'points_used' && details.points_used">
                <b-col
                  md="6"
                  class="text-capitalize payment-breakdown-label font-weight-bold text-success"
                  :key="`column-data-${paymentBreakdown}-${paymentBreakdownIndex}-label`"
                >
                  {{ paymentBreakdown.label }}: {{ details.points_used }}
                </b-col>
                <b-col
                  md="6"
                  :key="`column-data-${paymentBreakdown}-${paymentBreakdownIndex}-data`"
                  class="text-right payment-breakdown-value font-weight-bold text-success"
                >
                  - Php
                  {{ transformCurrencyValue(details.points_value) }}
                </b-col>
              </template>
          </b-row>
          <hr class="my-3" />
          <b-row>
            <b-col md="6" class="total-amount font-weight-bold">Total</b-col>
            <b-col class="text-right total-amount font-weight-bold">
              Php
              {{ transformCurrencyValue(details.computed_total_amount) }}
            </b-col>
          </b-row>
          <div v-if="details.points_earned" class="my-4">
            <PointsEarned :points="details.points_earned" :is-order-completed="details.order_transaction_status === 'completed'" />
          </div>
        </div>
      </b-col>
      <b-col
        md="7"
        id="orders-dine-in-order-details"
        class="h-100"
      >
      <div class="transaction-no font-weight-bold mb-3">{{ details.order_transaction_no }}</div>
        <div
          :class="[
            {
              'order-collapse-item mt-3':
                order.order_items.length,
            },
          ]"
          v-for="(order, orderIndex) of filteredOrders(details.order_list)"
          :key="`order-collapse-item-${orderIndex}`"
        >
          <template v-if="order.order_items.length">
            <div class="order-collapse-header">
              <div class="collapse-header">
                <span class="font-weight-bold">Order #{{ order.order_no }}</span> - Table {{ details.table_no }} ({{
                  order.customer_name
                }})
              </div>
              <b-button
                variant="ghost"
                v-b-toggle="`order-collapse-item-${orderIndex}`"
                class="border-0 rounded-0 shadow-none text-secondary"
              >
                <i class="accordion-caret" aria-hidden="true"></i>
              </b-button>
            </div>
            <b-collapse
              :id="`order-collapse-item-${orderIndex}`"
              class="order-collapse-item-index"
              :visible="
                orderIndex === filteredOrders(details.order_list).length - 1
              "
            >
              <b-row
                v-for="(item, itemIndex) of order.order_items"
                :key="`order-item-${itemIndex}`"
                class="mx-1"
                no-gutters
              >
                <b-col md="6">
                  <p class="text-primary mb-0">{{ item.product_name }}</p>
                  <div
                    v-for="(productItem, productItemIndex) of orderItemData"
                    :key="`order-product-item-${productItemIndex}-${itemIndex}`"
                    class="order-product-item"
                  >
                    {{ transformProductItemData(item, productItem) }}
                  </div>
                </b-col>
                <b-col md="3"> x{{ item.quantity }} </b-col>
                <b-col md="3">
                  &#8369; {{ transformCurrencyValue(item.item_price) }}
                </b-col>
              </b-row>
            </b-collapse>
          </template>
        </div>
      </b-col>
    </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { computed, defineComponent, onMounted } from "@vue/composition-api";
import { DateTime } from "luxon";
import PointsEarned from "../PointsEarned.vue";

export default defineComponent({
    components: {
      PointsEarned
    },
    setup(props, { root }) {
        const details = computed(() => {
            const orderDetails =
                root.$store.state.ordersDineIn.dine_in_order_details || null;

            if (orderDetails) {
                orderDetails.voucher_list = orderDetails.voucher_list.sort(
                    (a, b) =>
                        Number(b.is_welcome_discount) -
                        Number(a.is_welcome_discount)
                );
            }

            return orderDetails;
        });
        const columnedData = [
            { key: "customer_name", label: "Ordered by" },
            { key: "brand_branch", label: "Brand Branch" },
            { key: "created_at", label: "Date Ordered" },
        ];
        const columnedPaymentBreakdown = [
          { key: "subtotal_amount", label: "Subtotal" },
          { key: "fees" },
          { key: "points_used", label: "Points Redeemed"},
          { key: "voucher_list"}
        ];
        const transformCurrencyValue = value => {
            return Number(parseFloat(value).toFixed(2)).toLocaleString("en", {
                minimumFractionDigits: 2
            });
        };
        const orderItemData = ["variation_desc", "add_ons", "notes"];
        const transformProductItemData = (item, productItem) => {
            if (item[productItem] && productItem === "add_ons")
                return item[productItem]
                    .map(addOn => addOn.add_on_name)
                    .join(", ");
            else if (item[productItem] && productItem === "variation_desc")
                return item[productItem]
                    .map(variant => variant.value)
                    .join(", ");
            else if (item[productItem] && productItem === "notes")
                return `**${item[productItem]}**`;
            else return "";
        };
        const handleCloseDineInOrderDetails = () => {
            root.$store.commit("ordersDineIn/setOrderDineInDetails", null);
        };
        const getDetails = key => {
            if (key === "created_at")
                return DateTime.fromSQL(details.value[key]).toFormat(
                    "LL/dd/yyyy, hh:mma"
                );
            if (key === "brand_branch")
                return `${details.value.brand_name} (${
                    details.value.branch_name
                })`;
            
            return details.value[key];
        };
        const filteredOrders = orders => {
            return orders.filter(({ order_items }) => order_items.length > 0);
        };

        onMounted(() => {
            root.$on("bv::collapse::state", id => {
                if (
                    id &&
                    document.getElementById(id).classList.value.includes("show")
                ) {
                    document
                        .getElementById(id)
                        .previousSibling.classList.add("collapsed");
                } else
                    document
                        .getElementById(id)
                        .previousSibling.classList.remove("collapsed");
            });
        });

        return {
            details,
            columnedData,
            columnedPaymentBreakdown,
            transformCurrencyValue,
            orderItemData,
            transformProductItemData,
            handleCloseDineInOrderDetails,
            getDetails,
            filteredOrders
        };
    }
});
</script>


<style lang="scss">
#orders-dine-in-order-details-modal {
    * {
      font-family: MainFontRegular, sans-serif;
    }
    .close {
        right: 20px;
        color: #2f3941;
        font-family: serif;
        font-size: 36px;
    }
    .modal-dialog {
        max-width: 1080px;
    }
    .modal-content {
      padding: 0;
    }
    .modal-body {
        padding: 0;
        color: #2f3941;
        font-size: 16px;
    }
    .modal-title {
        width: 100%;
        text-align: center;
        &::after {
          background-color: #c8ccd1;
          width: 85px;
          left: 50%;
          transform: translateX(-50%);
        }
    }
    .transaction-no {
        font-size: 20px;
    }
    #order-details-container {
        height: calc(100vh - 150px);
    }
    #orders-dine-in-transaction-details {
        padding-top: 30px;
        padding-left: 28px;
        padding-right: 34px;
        height: 100%;
        overflow-y: auto;
        .details-label {
          font-size: 14px;
          color: #68737D;
        }
        .payment-breakdown-label {
            color: #63737d;
            font-size: 13px;
        }
        .payment-breakdown-value {
            color: #2f3941;
            font-size: 14px;
        }
        .total-amount {
            font-size: 18px;
        }
        .payment-details {
            margin-top: 32px;
            padding-top: 32px;
            padding-bottom: 30px;
        }
    }
    #orders-dine-in-order-details {
        background-color: #f9f9f9;
        padding-top: 30px;
        padding-right: 21px;
        height: 100%;
        overflow-y: auto;
        .order-collapse-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: #ffffff;
        }
        .collapse-header {
            color: #2f3941;
            padding: 16px;
        }
        .order-collapse-item {
            border: 0;
            background-color: transparent;
            .accordion-caret {
                width: 12px;
                height: 12px;
                display: inline-block;
                background: url("~@/assets/images/icons/expand-more.svg")
                    no-repeat center;
                transform: rotate(270deg);
            }
            & > .collapsed .accordion-caret {
                transform: rotate(360deg);
            }
        }
        .order-collapse-item-index {
            border-top: 1px solid #e9ebed;
            background-color: #ffffff;
            padding: 16px 12px;
        }
        .order-product-item {
            font-size: 12px;
            color: #87929d;
        }
    }
    img {
        vertical-align: baseline;
        height: 15px;
    }
}
</style>
